import { RouterManager } from '@aclass/admin/managers';
import { DomainDetailStory } from '@aclass/admin/storage/actions';
import { IAdminState, IDomainDetailModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class DomainDetailEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:domain-detail-edit';

    private id: string;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager,
    ) {
        super();
        this.resolver = this.ngRdx.select<IDomainDetailModuleState['editPageRecordId']>(['domainDetailModule', 'editPageRecordId']).pipe(
            filter(v => v === this.id)
        );
        this.employee = this.routerManager.onRejectNavigation(DomainDetailEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        // id = brand-locale
        this.id = route.params.id;
        this.ngRdx.dispatch(DomainDetailStory.dryRunEditPage(this.id));
    }
}
